import { render } from "./EditShipmentLabel.vue?vue&type=template&id=dbe31bc4&scoped=true&ts=true"
import script from "./EditShipmentLabel.vue?vue&type=script&lang=ts"
export * from "./EditShipmentLabel.vue?vue&type=script&lang=ts"

import "./EditShipmentLabel.vue?vue&type=style&index=0&id=dbe31bc4&lang=scss&scoped=true"
import "./EditShipmentLabel.vue?vue&type=style&index=1&id=dbe31bc4&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbe31bc4"]])

export default __exports__